import { Checkbox, Textarea } from '@nextui-org/react'
import CreateDropZone from './CreateDropZone'

export default function CompanyInsurance({ formData, handleChange, userUUID }) {
  return (
    <div className="flex flex-col gap-4">
      <Checkbox
        radius="full"
        checked={formData?.haveProfessionalLiabilityInsurance}
        onChange={(e) => handleChange?.('haveProfessionalLiabilityInsurance', e.target.checked)}
      >
        Have Liability Insurance
      </Checkbox>
      {formData?.haveProfessionalLiabilityInsurance && (
        <div className="flex flex-row gap-4">
          <div className="flex flex-1">
            <Textarea
              label="Coverage"
              labelPlacement="outside"
              variant="bordered"
              placeholder="your professional lability insurance coverage."
              classNames={{
                inputWrapper: 'flex flex-1',
              }}
              value={formData?.professionalLiabilityInsuranceCoverage}
              onChange={(e) => handleChange?.('professionalLiabilityInsuranceCoverage', e.target.value)}
            />
          </div>
          <div className="flex flex-1">
            <CreateDropZone
              title={'Certificate'}
              description="."
              onFilesChange={(files) => handleChange?.('professionalLiabilityInsuranceCertificate', files)}
              userUUID={userUUID}
              files={formData?.professionalLiabilityInsuranceCertificate ?? []}
            />
          </div>
        </div>
      )}
      <Checkbox
        radius="full"
        checked={formData?.haveGeneralLiabilityInsurance}
        onChange={(e) => handleChange?.('haveGeneralLiabilityInsurance', e.target.checked)}
      >
        Have General Liability Insurance
      </Checkbox>
      {formData?.haveGeneralLiabilityInsurance && (
        <div className="flex flex-row gap-4">
          <div className="flex flex-1">
            <Textarea
              label="Coverage"
              labelPlacement="outside"
              variant="bordered"
              placeholder="your general lability insurance coverage."
              classNames={{
                inputWrapper: 'flex flex-1',
              }}
              onChange={(e) => handleChange?.('generalLiabilityInsuranceCoverage', e.target.value)}
              value={formData?.generalLiabilityInsuranceCoverage}
            />
          </div>
          <div className="flex flex-1">
            <CreateDropZone
              title={'Certificate'}
              description="."
              onFilesChange={(files) => handleChange?.('generalLiabilityInsuranceFile', files)}
              userUUID={userUUID}
              files={formData?.generalLiabilityInsuranceFile ?? []}
            />
          </div>
        </div>
      )}
      <Checkbox
        radius="full"
        checked={formData?.haveCyberLiabilityInsurance}
        onChange={(e) => handleChange?.('haveCyberLiabilityInsurance', e.target.checked)}
      >
        Have Cyber Liability Insurance
      </Checkbox>
      {formData?.haveCyberLiabilityInsurance && (
        <div className="flex flex-row gap-4">
          <div className="flex flex-1">
            <Textarea
              label="Coverage"
              labelPlacement="outside"
              variant="bordered"
              placeholder="your cyber lability insurance coverage."
              classNames={{
                inputWrapper: 'flex flex-1',
              }}
              value={formData?.cyberLiabilityInsuranceCoverage}
              onChange={(e) => handleChange?.('cyberLiabilityInsuranceCoverage', e.target.value)}
            />
          </div>
          <div className="flex flex-1">
            <CreateDropZone
              title={'Certificate'}
              description="."
              onFilesChange={(files) => handleChange?.('cyberLiabilityInsuranceFile', files)}
              userUUID={userUUID}
              files={formData?.cyberLiabilityInsuranceFile ?? []}
            />
          </div>
        </div>
      )}
      <Textarea
        isRequired
        label="Risk Management Process"
        placeholder="Describe risk identification and mitigation."
        variant="bordered"
        labelPlacement="outside"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('riskManagementProcess', e.target.value)}
        value={formData?.riskManagementProcess}
      />
      <div className="flex flex-row gap-4">
        <div className="flex flex-1">
          <Textarea
            label="Information Security & Data Protection Policies"
            labelPlacement="outside"
            variant="bordered"
            placeholder="Overview and upload ISO 27001 or policy docs."
            classNames={{
              inputWrapper: 'flex flex-1',
            }}
            onChange={(e) => handleChange?.('informationSecurityText', e.target.value)}
            value={formData?.informationSecurityText}
          />
        </div>
        <div className="flex flex-1">
          <CreateDropZone
            title={'Certificate'}
            description="."
            onFilesChange={(files) => handleChange?.('informationSecurityFile', files)}
            userUUID={userUUID}
            files={formData?.informationSecurityFile ?? []}
          />
        </div>
      </div>
      <Textarea
        label="Health & Safety Policies"
        labelPlacement="outside"
        variant="bordered"
        placeholder="Policy summary if site work involved."
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        onChange={(e) => handleChange?.('healthSafetyPolicites', e.target.value)}
        value={formData?.healthSafetyPolicites}
      />
    </div>
  )
}
